import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges
} from '@angular/core';

import { VideogularComponent } from './videogular/Videogular.Component';

import { IVbSource } from './IVbSource';
import { VbOverlayBufferingManagerComponent } from './VbOverlayBufferingManager.Component';
import { VgStates } from './videogular/VgStates';

const INITIAL_BUFFERING_TIMEUPDATE_THRESHOLD: number = 10;

@Component({
	selector: 'initial-buffering-manager',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: ``,
	standalone: false
})
export class InitialBufferingManagerComponent implements OnChanges {
	@Input() public activeSource: IVbSource;
	@Input() public currentState: VgStates;
	@Input() public currentTime: boolean;
	@Input() public overlayBufferingManager: VbOverlayBufferingManagerComponent;

	@Output() public onInitialBufferingChange = new EventEmitter<{ isInitialBuffering: boolean }>();

	private isInitialBuffering: boolean;
	private updateCount: number;

	constructor(
		private vgApi: VideogularComponent
	) {}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.activeSource) {
			this.onActiveSourceChange();
		}

		if (changes.currentState) {
			this.onCurrentStateChange();
		}

		if (changes.currentTime) {
			this.onCurrentTimeChange();
		}
	}

	private onActiveSourceChange(): void {
		this.setToInitialBuffering();
	}

	private onCurrentStateChange(): void {
		if (
			this.vgApi.activeSource &&
			this.vgApi.activeSource.isLive &&
			this.currentState === VgStates.STOP
		) {
			this.setToInitialBuffering();
		}
	}

	private onCurrentTimeChange(): void {
		if (
			!this.isInitialBuffering ||
			this.currentState !== VgStates.PLAY ||
			this.overlayBufferingManager.isBuffering
		) {
			this.resetUpdateCount();
			return;
		}

		if (this.updateCount++ > INITIAL_BUFFERING_TIMEUPDATE_THRESHOLD) {
			this.onInitialBufferingChangeInternal(false);
		}
	}

	private onInitialBufferingChangeInternal(isInitialBuffering: boolean): void {
		this.isInitialBuffering = isInitialBuffering;

		this.onInitialBufferingChange.emit({
			isInitialBuffering
		});
	}

	private resetUpdateCount(): void {
		this.updateCount = 0;
	}

	private setToInitialBuffering(): void {
		this.onInitialBufferingChangeInternal(true);
		this.resetUpdateCount();
	}
}
